'use client';
import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const SkillBar = ({ title, percentage }) => {
  const { ref, inView } = useInView({ triggerOnce: true });

  return (
    <div ref={ref} className='skill-bar'>
      {/* <div style={{ marginBottom: '0.5rem', fontWeight: 'bold' }}>{title}</div> */}

      <div
        
        className='bar-inner'
      >
        <div
        className='bar progress-line color-1'
          style={{
            height: '100%',
            width: inView ? `${percentage}%` : '0%',
            backgroundColor: '#1976d2',
            transition: 'width 2s ease-out',
          }}
        >
        {inView && (
          <div
          className='skill-percent'
            style={{
              position: 'absolute',
              right: 0,
              background: '#000',
              color: '#fff',
              padding: '2px 6px',
              fontSize: '12px',
              borderRadius: '3px',
              transform: 'translateX(118%)',
              whiteSpace: 'nowrap',
            }}
          >
            <CountUp end={percentage} duration={2.5} />%
          </div>
        )}
        </div>
      </div>
    </div>
  );
};

export default SkillBar;
